<template>
  <div>
    <Head />
    <Navigation />
    <Wallpaper :src="src"/>
    <List :title="title" :items="items"/>
    <foot />
  </div>
</template>

<script>
import Head from '@/components/index/components/head'
import Wallpaper from '../components/wallpaper'
import List from '../components/list'
import Foot from '@/components/index/components/foot'
import Navigation from '@/components/index/components/nav'
export default {
  name: 'Products',
  components: {
    Head,
    Foot,
    Navigation,
    Wallpaper,
    List
  },
  data () {
    return {
      src: 'http://qkbx01f8g.hb-bkt.clouddn.com/wallpage2.jpg',
      title: '产品展示',
      items : [
        {listName:'机械产品设计分析软件',url:'/products/mob_1'},
        {listName:'实时交互仿真系统',url:'/products/mob_2'},
        {listName:'多物理计算系统',url:'/products/mob_3'},
        {listName:'云文档系统',url:'/products/mob_4'},
        {listName:'数据采集与实时监测',url:'/products/mob_5'},
        {listName:'实验室管理系统',url:'/products/mob_6'},
        {listName:'内容管理系统',url:'/products/mob_7'}
        ]
    }
  }
}
</script>

<style scoped>

</style>
